// パスワード画面 PASS表示非表示切り替え
$(function () {
    $('#passcheck').change(function () {
        if ($(this).prop('checked')) {
            $('#password').attr('type', 'text');
        } else {
            $('#password').attr('type', 'password');
        }
    });
});

// 確認パスワード画面 PASS表示非表示切り替え
$(function () {
    $('#confirm_passcheck').change(function () {
        if ($(this).prop('checked')) {
            $('#confirm_password').attr('type', 'text');
        } else {
            $('#confirm_password').attr('type', 'password');
        }
    });
});

// 現在のパスワード画面 PASS表示非表示切り替え
$(function () {
    $('#old_passcheck').change(function () {
        if ($(this).prop('checked')) {
            $('#old_password').attr('type', 'text');
        } else {
            $('#old_password').attr('type', 'password');
        }
    });
});

var changeColorCount = 0;  // 赤文字になるカウント
window.setupCharCounter = function(targetId, targetClass, maxCount, hasNewLineIsBrTag = false) {
    $(targetId).on('keyup', function() {
        if (hasNewLineIsBrTag) {
            value = $(this).val();
        } else {
            value = $(this).val().replace(/\n/g, "++");
        }
        var count = value.length;
        var countDown = (maxCount) - (count);
        if(countDown < changeColorCount) {
            $(targetClass).css({color: '#ff0000'});
        } else {
            $(targetClass).css({color: ''});
        }
        var format_countDown = '残り'+countDown+'文字';
        $(targetClass).text(format_countDown);
    });

    $(targetId).trigger("keyup");
};

// アコーディオン
$(function () {
  $(".js-accordion .c-accordion__ttl").on("click", function () {
    $(this).toggleClass("is_active");
    $(this)
      .next(".c-accordion__content")
      .slideToggle()
      .toggleClass("is_active");
  });
});

window.dear_send_ga = function (category, action, label)
{
    if (typeof gtag === "function") {
        gtag('event', action, {'event_category': category,'event_label': label});
    } else {
        console.warn('Google Analytics not installed');
    }
};


// 「再送」「削除」ポップアップ表示・非表示
$(function () {
    $(".action_area").on("click", function () {
      $(this).find('.hover_display').toggleClass("is_active");
      $(this).find('.hover_display')
        .next(".btn_area")
        // .slideToggle()
        .toggleClass("is_active");
    });
    $(".btn_area").hover(function() {
    }, function() {
        $(this).toggleClass("is_active");
    });	
  });

// 絞り込み detail表示非表示切り替え
$(document).ready(function () {
    $('.sort .select').click(function () {
        $('.sort .detail').toggleClass('detail_show');
    });
    $('.refine .select').click(function () {
        $('.refine .detail').toggleClass('detail_show');
    });
});

// ページ内リンク
$(function(){
    $('a[href^="#"]').click(function(){
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
});

$(function(){
    $('.close_alert_btn').on('click', function() {
        let target = $(this).data('target');
        $.ajax({
            url: "/api/u/common/limit-alert/close",
            type: "POST",
            data: { target: target },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function success($response) {
                $('.js-alert_'+target).hide();
            },
            error: function error(result, textStatus, xhr) {
            }
        });
    });
});

$(function(){
    $('.close_cannot_edit_ticket_alert_btn').on('click', function() {
        let target = $(this).data('target');
        $.ajax({
            url: "/api/u/common/cannot-edit-ticket-alert/close",
            type: "POST",
            data: { target: target },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function success($response) {
                $('.js-alert_'+target).hide();
            },
            error: function error(result, textStatus, xhr) {
            }
        });
    });
});